var map = {
	"./about-us.jpg": "9a77",
	"./company-four.jpg": "48a6",
	"./company-one.jpg": "564a",
	"./company-three.jpg": "47ea",
	"./company-two.jpg": "3ec0",
	"./test.jpg": "bfac",
	"./wechat.jpg": "5954",
	"./whatsapp.jpg": "3233"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "80dd";